var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    class: ['xybutton', _vm.type, _vm.disabled ? 'disabled' : ''],
    on: {
      "click": _vm.handleClick
    }
  }, [_vm.type ? _c('div', {
    staticClass: "icon"
  }) : _vm._e(), _c('div', [_vm._t("default")], 2)]);
};
var staticRenderFns = [];
export { render, staticRenderFns };